import { configureStore } from "@reduxjs/toolkit";
import SegReducer from "../redux/reducers/Segreducer";
import SeasonReducer from "../redux/reducers/SeasonReducer";
import DivisionReducer from "./reducers/DivisionReducer";
import ImprintReducer from "../redux/reducers/ImprintReducer";
import PaperCutOffDateReducer from "./reducers/PaperCutOffDateReducer";
import LdcReducer from "./reducers/LdcReducer";
import OTISReducer from "../redux/reducers/OTISReducer";
import UserReducer from "../redux/reducers/UserReducer";
import profileReducer from "../redux/reducers/profileReducer";
import dropdownReducer from "../redux/reducers/dropdownReducer";
import isbnReducer from "./reducers/ISBNSReducer";
import eanReducer from "./reducers/EansReducer";
import GrossSalesReducer from "./reducers/GrossSalesReducer";
import compInitReducer from "./reducers/FetchAllCompInitReducer";
import digPosReducer from "./reducers/fetchDigPosReducer";
import selectionSlice from "./reducers/Validationslice";


export const store = configureStore({
  reducer: {
    SegReducer,
    SeasonReducer,
    DivisionReducer,
    ImprintReducer,
    PaperCutOffDateReducer,
    LdcReducer,
    OTISReducer,
    profileReducer,
    UserReducer,
    dropdownReducer,
    isbnReducer,
    eanReducer,
    GrossSalesReducer,
    compInitReducer,
    digPosReducer,
    selection: selectionSlice,

  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppStore = typeof store; // type of our store variable

// Infer the RootState and App type from the store itself
export type RootState = ReturnType<AppStore["getState"]>;

export type AppDispatch = AppStore["dispatch"];
